
import Vue from 'vue';
import { VueEditor } from 'vue2-editor';
import { Button, Icon } from '@descomplica/vue-components';
import BackButton from '@/components/BackButton.vue';
import { ChannelModel } from '@/models/forumAPI/ChannelModel';
import { UserModel, CourseModel } from '@descomplica/dex-models';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { getCourseCategory } from '@/helpers/category';
import { FileModel } from '../models/FileModel';
import { getEditorSettings, handleImageAdded } from '../helpers/vue2editor';
import FileUpload from '@/components/files/FileUpload.vue';
import { VTooltip } from 'v-tooltip';

interface Data {
  discussionTitle: string;
  discussionDescription: string;
  titleInputMax: number;
  descriptionInputMax: number;
  editorSettings: any;
  fileToUpload: null;
  filesUploaded: FileModel[];
  resetFileUpload: Boolean;
  isCollapsed: Boolean;
}

export default Vue.extend({
  name: 'CreateDiscussion',
  components: {
    Button,
    VueEditor,
    BackButton,
    FileUpload,
    Icon,
  },
  directives: {
    tooltip: VTooltip,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      discussionTitle: '',
      discussionDescription: '',
      titleInputMax: 120,
      descriptionInputMax: 400,
      editorSettings: getEditorSettings({
        enableFileUpload: true,
        onFileAttached: (file: File) => {
          this.$data.fileToUpload = file;
          this.$data.resetFileUpload = false;
        },
      }),
      fileToUpload: null,
      filesUploaded: [] as FileModel[],
      resetFileUpload: false as Boolean,
      isCollapsed: false as Boolean,
    };
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.currentUser;
    },
    channel(): ChannelModel {
      const { channelId } = this.$route.params;
      return this.$store.getters.forumAPIChannelById(channelId);
    },
    isFormValid(): boolean {
      return this.discussionTitle.length > 0 && this.discussionDescription.length > 0;
    },
    course(): CourseModel {
      return this.user.getCourse();
    },
  },
  methods: {
    switCollapsed() {
      this.isCollapsed = !this.isCollapsed;
      window.scrollTo(0, 0);
    },
    updateFilesUploaded(files: FileModel[]) {
      this.filesUploaded = files;
    },
    autoSizeTextArea(element: HTMLInputElement, maxHeight: number) {
      if (element.scrollHeight < maxHeight) {
        element.style.overflow = 'hidden';
        element.style.height = 'auto';
        element.style.height = `${element.scrollHeight}px`;
      } else {
        element.style.overflow = 'auto';
      }
    },
    closeComponent() {
      this.$router.push({
        name: 'channel',
      });
    },
    async onSubmitDiscussion() {
      const newDiscussionID = await this.$store.dispatch('CREATE_DISCUSSION', {
        name: this.discussionTitle,
        text: this.discussionDescription,
        userId: this.user.id,
        channelId: this.channel.id,
        attachments: this.filesUploaded,
      });

      if (!newDiscussionID) {
        return;
      }

      this.resetFileUpload = true;

      Analytics.trackEvent(EVENT_LABELS.forumTopicCreated, {
        course: this.course.name,
        channel_id: this.channel.id,
        post_title: this.discussionTitle,
        category: getCourseCategory(this.course),
      });

      this.$router.push({
        name: 'discussion',
        params: {
          channelId: this.channel.id,
          discussionId: newDiscussionID,
        },
      });
    },
    async handleImageAdded(file: File, Editor: any, cursorLocation: any, resetUploader: Function) {
      handleImageAdded(file, Editor, cursorLocation, resetUploader, this.user.id);
    },
  },
});
